export default __webpack_public_path__ + "static/media/OrangeReader.f7765cbd.png";